export const unauthenticatedRoutes = [
  '/login',
  '/resetar-senha',
  '/escolha',
  '/first-access',
];
